import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ConsoleComponent } from './console.component';
import { ConsoleRoutingModule } from './console-routing.module';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { ConsoleMaintenanceComponent } from './components/console-maintenance/console-maintenance.component';
import { MatDividerModule } from '@angular/material/divider';
import { SharedModule } from 'src/app/shared';
import { GarbageCollectorSectionComponent } from './components/garbage-collector-section/garbage-collector-section.component';
import { GarbageCollectorStatisticComponent } from './components/garbage-collector-statistic/garbage-collector-statistic.component';
import { MatCardModule } from '@angular/material/card';
import { GarbageCollectorStatisticDialogComponent } from './components/garbage-collector-statistic-dialog/garbage-collector-statistic-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { APIInstanceService } from './services/api-instance.service';
import { MatButtonModule } from '@angular/material/button';
import { ConsoleSystemEventsComponent } from './components/console-system-events/console-system-events.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { InstanceModule } from '../instance/instance.module';

@NgModule({
    declarations: [
        ConsoleComponent,
        ConsoleMaintenanceComponent,
        GarbageCollectorSectionComponent,
        GarbageCollectorStatisticComponent,
        GarbageCollectorStatisticDialogComponent,
        ConsoleSystemEventsComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        ConsoleRoutingModule,
        MatListModule,
        MatIconModule,
        MatDividerModule,
        SharedModule,
        MatCardModule,
        MatDialogModule,
        MatButtonModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        InstanceModule
    ],
    providers: [APIInstanceService]
})
export class ConsoleModule {}
